// 按需改成你的后端地址
export const BASE_URL =
  process.env.NODE_ENV === 'production' ? '' : 'https://sc.ddd-dayz.cn'

// 后端未就绪时，设为 true 使用内置 Mock（可先跑通前端流程）
// Local visual preview can opt into demo data with VUE_APP_USE_MOCK=true.
// Production keeps using the real backend unless explicitly configured otherwise.
export const USE_MOCK = process.env.VUE_APP_USE_MOCK === 'true'
